export default {
  ACCORDION: {
    DEFAULT: 'default',
    FLAT: 'flat',
  },
  BUTTON: {
    DEFAULT: 'default',
    OUTLINED: 'outlined',
    TEXT: 'text',
  },
  CHECKBOX: {
    DEFAULT: 'default',
    INDETERMINATE: 'indeterminate',
  },
  CHIP: {
    DEFAULT: 'default',
    OUTLINED: 'outlined',
  },
  SEARCH: {
    INPUT: 'input',
    FILTER: 'filter',
  },
  LOADER: {
    SPINNER: 'spinner',
    DOTS: 'dots',
  },
  FORM_GROUP: {
    NONE: 'none',
    INPUT: 'input',
    INPUT_GROUP: 'input-group',
  },
};
